export const send = async (abi: any, options: any, gasRate: number = 1) => {
  let { estimateGasRate } = options;
  if(!estimateGasRate)
    estimateGasRate = gasRate;
  const gas = Math.floor((await abi.estimateGas(options)) * estimateGasRate);
  return abi.send({ ...options, gas });
}